<nz-layout class="self-report-section">
    <nz-header>
    </nz-header>
    <nz-content>
        <app-self-report />
    </nz-content>
</nz-layout>